import dynamic from "next/dynamic";

export const HotelShortVideos = dynamic(() =>
  import("./hotel-short-videos").then(
    ({ HotelShortVideos }) => HotelShortVideos
  )
);
